import {
  BdcPhotoMetadata,
  BdcPhotoGalleryPhotoItem,
  BdcPendingPhoto,
  BdcListingPhotoStatus,
} from '@tokeet-frontend/channel-content'

export interface BDCPhotoGridCardItem {
  photo_id: string
  url: string
  name?: string
  width?: number
  height?: number
  quality?: 'high' | 'medium' | 'low'
  message?: string
  tag_ids?: number[]
  isMain?: boolean
  status?: BdcListingPhotoStatus
  rooms?: number[]
}

export function transformToBDCPhotoGridCardItem(
  photo: BdcPhotoMetadata | BdcPhotoGalleryPhotoItem | BdcPendingPhoto,
  isMain: boolean = false
): BDCPhotoGridCardItem {
  const item = photo as any

  return {
    photo_id: item.photo_id,
    name: item.name,
    url: item.sample || item.url,
    width: item.width,
    height: item.height,
    quality: item.quality?.toLowerCase(),
    message: item.message || item.status_message,
    tag_ids: item.tag_ids,
    status: item.status,
    isMain,
    rooms: item.in_room_galleries?.map((r) => r.room_id),
  }
}
